import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85e4ea3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "tip" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点击查看内容", -1))

import { ref, onMounted } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Notification',
  setup(__props) {

const noteList = ref([
  {
    title: '消息通知1',
    id: 1,
    time: '1天前',
  },
  {
    title: '消息通知2',
    id: 2,
    time: '5天前',
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noteList.value, (item) => {
      return (_openBlock(), _createElementBlock("li", {
        key: item.id,
        class: "item"
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(item.title), 1),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(item.time), 1)
        ])
      ]))
    }), 128))
  ]))
}
}

})